export default {
    // ----------Title----------
    configuration: 'การกำหนดค่า',
    containerProps: 'คุณสมบัติของภาชนะ',
    productProps: 'คุณสมบัติของสินค้า',
    itemProps: 'คุณสมบัติของรายการ',
    customerProps: 'คุณค่าของลูกค้า',
    customerBranchProps: 'คุณสมบัติของสาขาลูกค้า',
    deliveryOrderProps: 'คุณสมบัติของใบสั่งส่งสินค้า',
    itemReceiveProps: 'คุณสมบัติของการรับรายการ'
}